import React, { useState } from 'react';
import ValidationTypes from '../../util/validationTypes';
import axios from 'axios';
import Dropdown from '../dropdown/Dropdown';
import LoadButton from './LoadButton';
import FeatureSwitch from './FeatureSwitch';
import useLoadingForm from '../../hooks/loadingFormHook';

import '../../styles/dashboard/DashboardBoostReviews.css';

export default function DashboardBoostReviews() {
    const [featureEnabled, setFeatureEnabled] = useState(false);
    const requestDays = [
        "1 day after delivery",
        "2 days after delivery",
        "3 days after delivery",
        "4 days after delivery",
        "5 days after delivery",
        "6 days after delivery",
        "7 days after delivery"
    ];

    const saveHandler = () => {
        return axios.get("https://flash.siwalik.in/delay/500");
    };

    const boostReviewsFormRules = {
        message: [ValidationTypes.requiredString],
        sendRequest: [ValidationTypes.requiredString]
    };

    const { formData, setFormData, loading, loaded, setLoaded, handleChange, handleSubmit, errorMapping } = useLoadingForm({
        message: '',
        sendRequest: ''
    }, saveHandler, null, null, boostReviewsFormRules);

    const handleFeatureSwitch = () => {
        setFeatureEnabled(!featureEnabled);
    }

    const handleDropdownChange = (item) => {
        if (loaded) {
            setLoaded(false);
        }

        setFormData({...formData, sendRequest: item});
    }

    return (
        <div className="DashboardBoostReviews">
            <div className="header relative">
                <h1>Boost Reviews</h1>
                <p>Automatically send personalized review request messages to buyers.</p>
                <FeatureSwitch 
                enabled={featureEnabled}
                handleClick={handleFeatureSwitch} />
            </div>
            <form 
            className="formDashboard content-split"
            onSubmit={handleSubmit}>
                <div className="request-message-section">
                    <label htmlFor="message">Custom Request Message</label>
                    <textarea 
                    className={errorMapping.message && 'form-error-input'}
                    name="message"
                    placeholder="Enter a message"
                    value={formData.message}
                    onChange={handleChange} />
                    {errorMapping.message && <p className="form-error">{errorMapping.message}</p>}
                </div>
                <div className="select-section">
                    <p className="label">Send request</p>
                    <Dropdown 
                    items={requestDays}
                    handleChange={handleDropdownChange}
                    errorText={errorMapping.sendRequest}
                    loading={loading} />
                    <LoadButton 
                    loading={loading}
                    loaded={loaded}
                    defaultText="Save!"
                    loadingText="Saving"
                    loadedText="Saved"
                    classes="black"
                    theme="white" />
                </div>
            </form>
            <p className="disclaimer">DISCLAIMER! Depop is highly against spam. Try to switch up 
             your messages often and do not overuse this feature to ensure you aren’t flagged for spam</p>
        </div>
    )
}